import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/GameController.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "GameControllerIcon";
const c = e;
export {
  c as GameController,
  e as GameControllerIcon
};
